import React, { memo } from 'react';

export const ButtonLinkItem = memo(({ label, value, onClick, ...res }) => {
  return (
    <button className="link" type="button" onClick={() => onClick(value)} {...res}>
      {label}
    </button>
  );
});
